import { formatMoney } from 'libs/shopify'

function SaleOffPrice({ saleOff, className = '', classWrapper = '', hasSaleTag = false, compareAtPrice = null }) {
  if (!saleOff) return null

  const { onlinePrice, rrp, was } = translate.product

  const label = hasSaleTag ? `${saleOff}% Off` : onlinePrice
  const prefix = hasSaleTag ? was : rrp
  const textColor = hasSaleTag ? 'text-error-content' : 'text-grey-500'
  const bgColor = hasSaleTag ? 'bg-error-content' : 'bg-grey-500'

  return (
    <p className={`inline-flex h-5 items-center overflow-hidden ${classWrapper}`}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 10 20'
        className={`-mr-0.5 h-[30px] w-2.5 ${textColor}`}
      >
        <path
          fill='currentColor'
          d='M10 18.394V1.606C10-.374 7.434-1.15 6.336.496L.74 8.891a2 2 0 0 0 0 2.218l5.596 8.395c1.098 1.646 3.664.87 3.664-1.11Z'
        />
      </svg>

      <span className={`rounded-r-sm text-white ${bgColor} ${className}`}>
        {label}
      </span>

      {compareAtPrice && (
        <span className='ml-3 text-lg leading-[28px] text-grey-500 line-through'>
          {prefix} {formatMoney(compareAtPrice)}
        </span>
      )}
    </p>
  )
}

export default SaleOffPrice
